// require 3rd party modules
let $ = require('jquery');
let nunjucks = require('nunjucks');

// require own modules
let pins = require('./pins')

// redux store
let store

// references to check if parts of state have changed
let activeFilters
let discreteFilters
let filteredItems
let pagination
let extendedFiltersOpen = false

// initial state
const initialState = {
	pagination: {
		page: 0
	},
	viewInitialized: false
}

// set redux store reference and subscribe to state changes
function init(_store) {
	store = _store
	store.subscribe(subscribe)
}

// subscribe to action dispatches
function subscribe() {
	const state = store.getState()
	if(!state.filtersInitialized) {
		return
	}

	if(!state.viewInitialized) {
		return initializeView(store)
	}

	updateView(store)
}

// update filters and list
function updateView(store) {
	const state = store.getState()
	if(state.activeFilters == activeFilters && state.filteredItems == filteredItems && state.pagination == pagination && state.extendedFiltersOpen == extendedFiltersOpen) {
		return
	}

	// either active filters have changed or extended filter dropdown was toggled
	if(state.activeFilters !== activeFilters || state.extendedFiltersOpen !== extendedFiltersOpen) {
		// render subparts
		renderButtons(state)
		renderSelects(state)

		// write search word to filters
		$('.sortenfinder-filter').find('input.search-field-input').val(state.activeFilters.text || '')

		// update references
		activeFilters = state.activeFilters
		discreteFilters = state.activeFilters.discrete
		extendedFiltersOpen = state.extendedFiltersOpen
	}

	// items have newly been filtered
	if(state.filteredItems !== filteredItems) {
		filteredItems = state.filteredItems
		// render subparts
		renderList(state)
		renderSelects(state)
		renderInfo(state)
	} else if(state.pagination !== pagination) {
		renderPagination(state)
		pagination = state.pagination
	}

	// update memo pins
	pins.updatePinClasses()
	store.dispatch({type: 'updatedView'})
}

// init view
function initializeView(store) {
	const state = store.getState()
	nunjucks.configure(state.config.nunjucks.templatePath, state.config.nunjucks.config);
	renderButtons(state)

	store.dispatch({type: 'inititializedView'})
}

// for now we use infinite scroll
function renderPagination(state) {
	if(!state.filteredItems) {
		return;
	}
	let {start,end} = calculatePagination(state)
	let content = state.filteredItems.slice(start, end)
	if(content.length) {
		let html = nunjucks.render('content-list.html.twig', {contents: content, lang: state.lang, pagelink: state.detailUri,sustainer: state.sustainerUri, loginStatus: state.loginStatus, sustainerMissing: state.sustainerMissing, becomeSustainer: state.becomeSustainer, commercialOffer: state.commercialOffer, orderActive: state.orderActive, details: state.details, hideOrderDetails: state.hideOrderDetails})
		$('.sortenfinder-list__contents').append(html)
	}
}

// main filters, category, species, subspecies
function renderButtons(state) {
	state.mainFilters.map((mainFilter, index) => {
		let filterKey = mainFilter.key
		let options = [...mainFilter.options.values()]

		// filter out active filters not allowed by parent
		if(index){
			let activeParent = state.activeFilters.discrete.get(state.mainFilters[index - 1]);
			if(activeParent) {
				options = options.filter(option => activeParent.relations.has(option))
			} else {
				options = []
			}
		}

		// set selected options active
		options.map(option => {
			let parent = state.filters.get(option.key)
			// set options tags
			// note this is dirty because we change redux state outside a reducer
			// however the active flag is only used in this function so we use this for convenience
			option.active = state.activeFilters.discrete.get(parent) === option
		})

		// alphabetical
		options.sort((a,b) =>  a.label.localeCompare(b.label))

		// container div of the filter buttons
		let container = $('.filter-' + filterKey)
		// get labels from state
		let {filterLabel, searchTextSingular, searchTextPlural, searchTitle, filterBySubLabel, filterBySubSubLabel} = state

		// if there are any options render the buttons
		if(options.length) {
			let html = nunjucks.render('filter-' + filterKey + '.html.twig', {filters: options, filterLabel, searchTextSingular, searchTextPlural, searchTitle, filterBySubLabel, filterBySubSubLabel})
			container.show().html(html)
		} else {
			container.hide()
		}
	})
}

// extended filters
// @todo this cann probably made a bit simpler
function renderSelects(state) {
	let extendedFilterOrder = state.config.extendedFilterOrder
	let extendedFilters = [...state.filters.values()].filter(filter => !state.mainFilters.includes(filter))
	let availableFilters = new Set()

	// only those filters are available that are found in filtered items
	state.filteredItems.map(item => {
		for(let filter of item.filters) {
			availableFilters.add(filter)
		}
	})

	// get select object to hand over to nunjucks view
	let selectObjects = extendedFilters.reduce((selectObjects, filter) => {
		selectObjects.push({
			label: state.label[filter.tag],
			tag: filter.tag,
			options: [...filter.options.values()]
				.filter(option => availableFilters.has(option))
				.map(option => {
					option.active = state.activeFilters.discrete.get(filter) === option
					return option
				})
		});
		return selectObjects
	}, []).filter(select => select.options.length)

	// filter out selects not allowed by main filters
	state.mainFilters.map((mainFilter) => {
		let activeFilter = state.activeFilters.discrete.get(mainFilter)
		if(activeFilter) {
			selectObjects = selectObjects.filter(filter => {
				filter.options = filter.options.filter(option => {
					return activeFilter.relations.has(option)
				})
				return filter.options.length
			})
		}
	})

	// sort options by key (month options)
	// or by label (else)
	selectObjects.map(filter => filter.options.sort((a,b) => {
		if(state.config.extendedSortByKey.includes(a.key)) {
			return a.index - b.index
		} else {
			return a.label.localeCompare(b.label)
		}
	}))

	// sort the selects themselves
	selectObjects.sort((a,b) => {
		return extendedFilterOrder.indexOf(a.tag) - extendedFilterOrder.indexOf(b.tag)
	})

	// render html
	let html = nunjucks.render('filter-extended.html.twig',{filters: selectObjects, keepOpen: state.extendedFiltersOpen, filterByDropdown: state.searchLabel})
	$('.filter-extended').html(html)
}

// info header with count of found objects
function renderInfo(state) {
	if(!state.filteredItems) {
		return
	}

	let html = nunjucks.render('search-result-count.html.twig', {count: state.filteredItems.length, resultTitle: state.searchTitle, resultTextSingular: state.searchTextSingular, resultTextPlural: state.searchTextPlural});
	$('.search-container-info').html(html)
}

// render list
function renderList(state) {
	if(!state.filteredItems) {
		return;
	}
	let content = state.filteredItems.slice(0, state.config.pagination.initial)
	let html = nunjucks.render('content-list.html.twig', {contents: content, lang: state.lang, pagelink: state.detailUri,sustainer: state.sustainerUri, loginStatus: state.loginStatus, sustainerMissing: state.sustainerMissing, becomeSustainer: state.becomeSustainer, commercialOffer: state.commercialOffer, orderActive: state.orderActive, details: state.details, hideOrderDetails: state.hideOrderDetails})
	$('.sortenfinder-list__contents').html(html)
}

// calculate number of items displayed
// for infinite scroll
function calculatePagination(state) {
	let {page} = state.pagination
	let {initial, reload} = state.config.pagination

	let start = page > 0 ? initial + (page - 1) * reload : 0
	let end = initial + page * reload
	return {start, end}
}

module.exports = {
	initialState,
	init,
	reducers: {
		'inititializedView': (state, action) =>{
			state.viewInitialized = true
			return state
		},
		'pagination': (state, action) => {
			if(!state.filteredItems) {
				return state
			}

			if(action.value = 'next') {
				state.pagination = {
					page: state.pagination.page + 1
				}
			}
			return state
		}
	}
}
